<template>
  <div class="hp-base-panel-wrp">
    <div class="desc-panel hp-base-panel">
      <div class="hp-title">
        <em class="left">个人介绍</em>
      </div>
      <div class="author-desc">
        <yxlMore
          :lineClamp="5"
          :info="introduction"
          @setShowAllCallback="setShowAllCallback"
        ></yxlMore>
      </div>
    </div>
  </div>
</template>

<script>
import yxlMore from 'component/common/yxlMore.vue'

export default {
  components: {
    yxlMore
  },
  props: {
    introduction: String
  },
  methods: {
    setShowAllCallback(showall) {
      // 展开全部埋点
      if (showall) {
        this.$trackEvent('newprofilepages_selfintroduction_all', {})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.hp-title {
  padding-bottom: 26px !important;
  padding-top: 50px;
  &:nth-of-type(1) {
    padding-top: 0;
  }
}
.desc-panel {
  .author-desc {
    /deep/ .yxl-more {
      .content {
        white-space: pre-wrap !important;
      }
    }
    /deep/ .text {
      font-size: 26px;
      color: #6c798c !important;
    }
    /deep/ .btn {
      font-size: 26px;
      color: #6982fa;
    }
  }
}
</style>
